import { render, staticRenderFns } from "./ContentParametersReview.vue?vue&type=template&id=25d2800b&scoped=true&"
import script from "./ContentParametersReview.vue?vue&type=script&lang=js&"
export * from "./ContentParametersReview.vue?vue&type=script&lang=js&"
import style0 from "./ContentParametersReview.vue?vue&type=style&index=0&id=25d2800b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d2800b",
  null
  
)

export default component.exports